<div class="e-results-container">
    <div class="e-search-bar-container">
        <via-search-bar></via-search-bar>
    </div>
    <div class="e-results-layout">
        <div class="e-filters" role="region" aria-label="Filters">
            <via-filter-tabs [isOverlay]="true"></via-filter-tabs>
        </div>
        <div class="e-results-list" role="main">
            <via-sorting-options></via-sorting-options>
            <via-results-list></via-results-list>
        </div>
        <div class="e-sku-set-options" role="region" aria-label="SKU Set options">
            <via-sku-set-options></via-sku-set-options>
        </div>
    </div>
</div>
